import React from 'react';
import ButtonsSubmitCancel from '../ButtonsSubmitCancel';
import TabsHolder from '../../../../common/components/TabsHolder';
import TabTaxAuthority from "../TabTaxAuthority";
import TabFirm from '../TabFirm';
import TabShared from '../TabShared';
import TabSurveyAssets from '../TabSurveyAssets';
import TabSavedRows from '../TabSavedRows';
import FormTitle from "../FormTitle";
import styles from './styles.module.scss';
import {TabSavedRowsContextProvider} from "../TabSavedRows/TabSavedRowsContext";

const Form_9View = ({prevPagePath, nextPagePath, allowInspectionsShare}) => {
  return (
    <div className={styles.form_9}>
      <FormTitle title={'נכסי השוואה'}/>
      <div className={styles.formContent}>
        <TabsHolder
          showLastTabDivider={true}
          tabs={[
            {
              id: 0,
              title: 'רשות המיסים', // new crawler data
              content: (
                <div className={styles.unit}>
                  <TabTaxAuthority customClassNames={styles}/>
                </div>
              )
            },
            {
              id: 1,
              title: 'מאגר דוחות המשרד', // office DB
              content: (
                <div className={styles.unit}>
                  <TabFirm customClassNames={styles}/>
                </div>
              )
            },
            {
              id: 2,
              title: 'מאגר מידע שיתופי', // common DB - inspections (status 5) of other users from your firm if allowed to share
              content: (
                <div className={styles.unit}>
                  <TabShared customClassNames={styles}/>
                </div>
              ),
              disabled: !allowInspectionsShare
            },
            {
              id: 3,
              title: 'סקר נתוני היצע', // Supply data survey
              content: (
                <div className={styles.unit}>
                  <TabSurveyAssets customClassNames={styles}/>
                </div>
              )
            },
            {
              id: 4,
              title: 'נכסים שנבחרו', // Selected properties
              content: (
                <div className={styles.unit}>
                  <TabSavedRowsContextProvider>
                    <TabSavedRows customClassNames={styles}/>
                  </TabSavedRowsContextProvider>
                  <ButtonsSubmitCancel
                    prevPagePath={prevPagePath}
                    nextPagePath={nextPagePath}
                  />
                </div>
              )
            },
          ]}
        />
      </div>
    </div>
  );
};

export default Form_9View;